import React from "react";

const TextItem = ({ icon, text }) => {
  return (
    <div className="text-item">
      {icon && <div>{icon}</div>}
      <p>{text}</p>
    </div>
  );
};

export default TextItem;
